import { Component, ChangeDetectionStrategy, signal, inject, DestroyRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FragmentNavigationService } from '../../services/fragment-navigation.service';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-navbar',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  private readonly siteConfig = inject(SiteConfigService);
  private readonly fragmentNav = inject(FragmentNavigationService);
  private readonly document = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);

  readonly isScrolled = signal(false);
  readonly mobileMenuOpen = signal(false);
  readonly navItems = this.siteConfig.navigation;
  readonly profile = this.siteConfig.profile;

  constructor() {
    const win = this.document.defaultView;
    if (win) {
      fromEvent(win, 'scroll')
        .pipe(debounceTime(10), takeUntilDestroyed(this.destroyRef))
        .subscribe(() => this.isScrolled.set(win.scrollY > 40));
    }
  }

  scrollTo(fragment: string): void {
    this.fragmentNav.navigateToFragment(fragment);
    this.mobileMenuOpen.set(false);
  }

  scrollToTop(): void {
    this.document.defaultView?.scrollTo({ top: 0, behavior: 'smooth' });
  }

  toggleMenu(): void {
    this.mobileMenuOpen.update(v => !v);
  }
}
